export class FilterPropertyGeneric<T> {
  id: T;
  displayName: string;
  createdDate: number;
  tooltip?: string;

  public set(id: any, displayName: string): FilterPropertyGeneric<T> {
    this.id = id;
    this.displayName = displayName;
    return this;
  }
}

export class FilterProperty extends FilterPropertyGeneric<string> {}
